@font-face {
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url('/fonts/noto-sans-v42-latin_latin-ext-regular.woff2') format('woff2');
}
@font-face {
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: url('/fonts/noto-sans-v42-latin_latin-ext-500.woff2') format('woff2');
}
@font-face {
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 600;
  font-display: swap;
  src: url('/fonts/noto-sans-v42-latin_latin-ext-600.woff2') format('woff2');
}
@font-face {
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url('/fonts/noto-sans-v42-latin_latin-ext-700.woff2') format('woff2');
}
@font-face {
  font-family: 'Noto Sans Mono';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url('/fonts/noto-sans-mono-v37-latin_latin-ext-regular.woff2') format('woff2');
}
@font-face {
  font-family: 'Noto Sans Mono';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url('/fonts/noto-sans-mono-v37-latin_latin-ext-700.woff2') format('woff2');
}
:root {
  --font-standard: 'Noto Sans', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;
  --font-number: 'Noto Sans Mono', ui-monospace, 'Cascadia Code', Menlo, Consolas, monospace;
  --fs-xs: 12px;
  --fs-sm: 13px;
  --fs-base: 15px;
  --fs-title: 19px;
  --fs-heading: 24px;
  --fs-page-title: var(--fs-title);
  --ff-page-title: var(--font-standard);
  --fs-nav-item: var(--fs-base);
  --ff-nav-item: var(--font-standard);
  --ff-numeric-value: var(--font-number);
  --fs-numeric-value: var(--fs-base);
}
